module.exports = __webpack_public_path__ + "img/item-25.e47f954c.svg";